export default __webpack_public_path__ + "static/media/QRCODE.c4bddd59.svg";